export const categories = [
  {
    name: 'Shoes',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    icon: 'ri-shopping-bag-3-line',
    imagePrompt: 'Stylish pair of sneakers photographed on a clean white surface with soft natural daylight, modern minimalist product photography, crisp details showing texture and design, warm neutral background, editorial sneaker showcase, simple elegant composition',
  },
  {
    name: 'Hoodies/Sweaters',
    url: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
    icon: 'ri-shirt-line',
    imagePrompt: 'Cozy oversized hoodie folded neatly on a light beige surface, soft warm lighting from window, comfortable casual aesthetic, visible fabric texture, minimalist fashion product photography, clean and inviting composition',
  },
  {
    name: 'T-Shirts',
    url: 'https://kaspreadsheet.com/search-913/name/Shoes.html',
    icon: 'ri-t-shirt-line',
    imagePrompt: 'Crisp white t-shirt laid flat on a light wooden surface, soft natural daylight, clean minimalist aesthetic, visible fabric quality and stitching details, modern fashion product photography, simple sophisticated composition',
  },
  {
    name: 'Jackets',
    url: 'https://kaspreadsheet.com/search-914/name/Shoes.html',
    icon: 'ri-vip-line',
    imagePrompt: 'Stylish bomber jacket hanging on a minimalist wooden hanger against a soft neutral wall, warm ambient lighting, visible texture and design details, modern fashion editorial style, clean sophisticated product photography',
  },
  {
    name: 'Pants/Shorts',
    url: 'https://kaspreadsheet.com/search-915/name/Shoes.html',
    icon: 'ri-archive-line',
    imagePrompt: 'Well-fitted casual pants folded elegantly on a light cream surface, soft natural side lighting, clean minimalist aesthetic, visible fabric drape and texture, modern fashion product photography, warm inviting tones',
  },
  {
    name: 'Headwear',
    url: 'https://kaspreadsheet.com/search-916/name/Shoes.html',
    icon: 'ri-user-3-line',
    imagePrompt: 'Stylish baseball cap placed on a clean white surface with soft shadows, natural daylight, visible embroidery details and fabric texture, modern accessory product photography, minimal clean composition with warm tones',
  },
  {
    name: 'Sets',
    url: 'https://kaspreadsheet.com/search-917/name/Shoes.html',
    icon: 'ri-stack-line',
    imagePrompt: 'Coordinated fashion set including matching top and bottom laid out beautifully on a light wooden surface, soft natural lighting, modern minimalist aesthetic, editorial fashion flat lay photography, harmonious color palette',
  },
  {
    name: 'Underwear/Underpants',
    url: 'https://kaspreadsheet.com/search-918/name/Shoes.html',
    icon: 'ri-checkbox-blank-line',
    imagePrompt: 'Premium cotton underwear set folded neatly on a soft cream fabric surface, gentle diffused lighting, clean minimalist aesthetic, visible quality fabric texture, tasteful product photography, warm and inviting composition',
  },
  {
    name: 'Jersey',
    url: 'https://kaspreadsheet.com/search-919/name/Shoes.html',
    icon: 'ri-team-line',
    imagePrompt: 'Sports jersey displayed flat on a clean white surface with soft studio lighting, visible team colors and fabric details, modern athletic wear product photography, crisp and vibrant composition, professional sporty aesthetic',
  },
  {
    name: 'Accessories',
    url: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
    icon: 'ri-glasses-line',
    imagePrompt: 'Collection of stylish accessories including sunglasses and a watch arranged on a light marble surface, soft natural daylight, modern luxury aesthetic, clean sophisticated product photography, elegant minimalist composition',
  },
  {
    name: 'Bags',
    url: 'https://kaspreadsheet.com/search-921/name/Shoes.html',
    icon: 'ri-shopping-bag-line',
    imagePrompt: 'Stylish backpack placed on a clean light wooden surface with soft natural lighting, visible material texture and design details, modern accessory product photography, minimalist composition with warm ambient tones',
  },
  {
    name: 'Belts',
    url: 'https://kaspreadsheet.com/search-922/name/Shoes.html',
    icon: 'ri-link',
    imagePrompt: 'Premium leather belt elegantly coiled on a light cream surface with soft shadows, natural daylight, visible leather grain texture and buckle detail, modern accessory product photography, clean sophisticated composition',
  },
  {
    name: 'Perfumes',
    url: 'https://kaspreadsheet.com/search-923/name/Shoes.html',
    icon: 'ri-drop-line',
    imagePrompt: 'Elegant perfume bottle on a light marble surface with soft diffused lighting, modern luxury aesthetic, visible glass reflections and design details, sophisticated product photography, clean minimalist composition with warm tones',
  },
  {
    name: 'Other Stuff',
    url: 'https://kaspreadsheet.com/search-924/name/Shoes.html',
    icon: 'ri-more-line',
    imagePrompt: 'Eclectic collection of lifestyle products including gadgets and home accessories arranged on a light wooden surface, soft natural daylight, modern minimalist aesthetic, editorial product flat lay photography, warm inviting composition',
  },
];